import moment from 'moment';

export default function formatDate(date) {
  if (date === null || date === undefined) {
    return '';
  }
  return moment(date).format('DD/MM/YYYY');
}



// WEBPACK FOOTER //
// ./src/services/general/formatDate.js